import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import RichText from "../components/richText"
import TagList from "../components/tagList"
import styles from "./scrap.module.scss"

const Scrap = ({ data }) => {
  const { title, body , tag, videoEmbedText } = data.contentfulScrap;
  return (
    <Layout>
      <SEO title={title} />
      <div className={styles.Scrap}>
        <div className={styles.scrapBox}>
          <div className={styles.title}>{title}</div>
          <div className={styles.tagListWrapper}><TagList tag={tag} /></div> 
          <div className={styles.videoWrapper}>
              <div className={styles.videoWrapperInner}
                dangerouslySetInnerHTML={{
                  __html:
                  videoEmbedText.videoEmbedText,
                }}
              />
          </div>
          <div className={styles.bodyWrapper}><RichText content={body} /></div>
        </div>
        <div className={styles.backButtonWrapper}><Link to="/">Home</Link></div>
      </div>
    </Layout>
  );
};
export default Scrap;
export const pageQuery = graphql`
  query($slug: String!) {
    contentfulScrap(slug: { eq: $slug }) {
      title
      slug
      body {
        body
        json
      }
      tag {
        name
        slug
      }
      videoEmbedText {
        videoEmbedText
      }
    }
  }
`;